import React, { useState, useEffect } from 'react';
import './ImageModal.css';

const ImageModal = ({ image, onClose }) => {
  const [isClosing, setIsClosing] = useState(false);

  // Handle ESC key to close modal
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        handleClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 200); // Match animation duration
  };

  const handleOverlayClick = (e) => {
    // Close if clicking directly on overlay (not on image)
    if (e.target.classList.contains('image-modal-overlay')) {
      handleClose();
    }
  };

  return (
    <div
      className={`image-modal-overlay ${isClosing ? 'closing' : ''}`}
      onClick={handleOverlayClick}
    >
      <div className={`image-modal-content ${isClosing ? 'closing' : ''}`}>
        <button
          className="image-modal-close"
          onClick={handleClose}
          aria-label="Stäng"
        >
          ×
        </button>

        <img
          src={image.url}
          alt={image.title}
          className="image-modal-image"
        />

        <div className="image-modal-info">
          <h3 className="image-modal-title">{image.title}</h3>
          <p className="image-modal-description">
            {image.description} • {image.timestamp}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
